import { Outlet, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import Header from './Navbar/Header';

const GuestLayout = ({ children }) => {
    const location = useLocation();
    
    // Páginas de autenticação que não devem ter padding-top
    const authPages = ['/signin', '/signup', '/ForgotPassword', '/RecoveryPassword'];
    const isAuthPage = authPages.some(page => location.pathname.includes(page));
    
    return (
        <Box>
            <Header />
            <Box sx={{
                minHeight: '100vh',
                // Aplicar padding-top apenas em páginas não-autenticação
                pt: isAuthPage ? 0 : { xs: 'calc(64px + max(env(safe-area-inset-top, 0px), 10px))', sm: '64px' },
                // Garantir que o conteúdo não fique atrás do header
                marginTop: isAuthPage ? 0 : { xs: 'max(env(safe-area-inset-top, 0px), 10px)', sm: 0 },
                // Reduzir padding em mobile para evitar conteúdo cortado
                pb: { xs: 2, sm: 0 }
            }}>
                <Outlet /> {children}
            </Box>
        </Box>
    );
};

export default GuestLayout;

// const GuestLayout = ({ isLoggedIn, setLoggedIn }) => {
//     return (
//         <div>
//             <Header isLoggedIn={isLoggedIn} setLoggedIn={setLoggedIn} />
//             <Outlet /> {/* Renderiza as rotas aninhadas */}
//         </div>
//     );
// };
